import { useEffect } from "react";
import { useParams } from "react-router";

import { resolveShareLink, SHARE_LINK_PREFIXES } from "../lib/shareSlug";
import { tryOpenAlbaVoxApp } from "../lib/openInApp";
import { AppLinkFallback } from "./AppLinkFallback";

export function ShortShareLink() {
  const { sharePrefix = "", slug = "" } = useParams();
  const isValidPrefix = SHARE_LINK_PREFIXES.includes(
    sharePrefix as (typeof SHARE_LINK_PREFIXES)[number],
  );

  useEffect(() => {
    if (!slug || !isValidPrefix) return;
    tryOpenAlbaVoxApp(`/${sharePrefix}/${slug}`, window.location.search);
  }, [sharePrefix, slug, isValidPrefix]);

  if (!isValidPrefix || !resolveShareLink(sharePrefix, slug)) {
    return (
      <AppLinkFallback
        title="This AlbaVox link is invalid"
        description="The shared link could not be opened. Continue to AlbaVox or install the app below."
      />
    );
  }

  return (
    <AppLinkFallback
      title="Opening in AlbaVox"
      description="Redirecting you to the app…"
      autoOpen={false}
    />
  );
}
